export default __webpack_public_path__ + "static/media/section2_81.36e79254.png";